import React from 'react'
import { Linking } from 'react-native'
import { useTranslation } from 'react-i18next'

import { useParams } from '../../../Router'
import { DefaultButtonWithText } from '../ButtonWithText/style'
import { AbsoluteSpinner } from '../Spinners'

import { IProps } from './IProps'
import { useAppSelector } from '../../../store/hooks'
import { customerPortalLinks } from '../../Util/customerPortalUrl'

export const PreviousAppointmentsButton: React.FunctionComponent<IProps> = ({
  rootPathCheck,
}) => {
  const { establishmentId } = useParams()
  const { t } = useTranslation()
  const { settings } = useAppSelector((state) => ({
    settings: state.settings.values,
  }))

  if (typeof settings === 'undefined') {
    return <AbsoluteSpinner />
  }

  return rootPathCheck ? (
    <DefaultButtonWithText
      backgroundcolor={settings.backgroundColor}
      fontcolor={settings.highlightColor}
      hoversensitive
      onPress={() => Linking.openURL(customerPortalLinks.appointments(establishmentId))}
    >
      {t('Manage my appointments')}
    </DefaultButtonWithText>
  ) : null
}
